import { PositionUpdaters, PositionUpdaterProps } from './types';

const REVERTED = 'data-reverted';

const calcStyles = (submenu: HTMLElement) => {
  const {
    paddingTop,
    paddingLeft,
    paddingRight,
    borderTopWidth,
  } = getComputedStyle(submenu);

  // padding is needed to not loose hover when cursor is moving to sub sub menu
  const padding = `padding-left: ${paddingLeft}; padding-right: ${paddingRight};`;
  // negative margin is needed to align items properly
  const margin = `margin-top:-${Number.parseInt(paddingTop, 10) +
    Number.parseInt(borderTopWidth, 10)}px;`;

  return `${padding}${margin}`;
};

export const depth1PositionUpdaters: PositionUpdaters = {
  onEnter: ({ positionBox, label, isRTL }: PositionUpdaterProps) => {
    positionBox.style.cssText = calcStyles(
      positionBox.firstChild as HTMLElement,
    );
    const { left, right } = label.getBoundingClientRect();
    // align should be reverted if there is not enough space for element to render
    const shouldBeReverted = isRTL
      ? left - positionBox.offsetWidth < 0 // left edge is out of viewport
      : right + positionBox.offsetWidth > document.body.offsetWidth; // right edge is out of viewport
    if (shouldBeReverted) {
      positionBox.setAttribute(REVERTED, 'true');
    }
  },
  onLeave: ({ positionBox }: PositionUpdaterProps) => {
    positionBox.removeAttribute(REVERTED);
    positionBox.style.cssText = '';
  },
};
